<template>
    <div class="col-md-12 px-2 py-2 mt-5">
        <form
            action=""
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
        >
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Variable</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="slug"
                        placeholder="Seleccione una variable"
                        :options="arraySlug"
                    ></multiselect>
                    <span v-if="allerrors.slug" :class="['show-error']">{{
                        allerrors.slug[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Enunciado</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="question"
                        class="form-control"
                        placeholder="Ingrese su enunciado"
                    />
                    <span v-if="allerrors.question" :class="['show-error']">{{
                        allerrors.question[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Crear
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            question: null,
            slug: null,
            order: 0,
            allerrors: {
                question: null,
                slug: null,
            },
            arraySlug: [
                    'solve_what',
                    'solve_how',
                    'other_financing',
                    'differentiator',
                    'problem_population',
                    'initiative',
                    'expand_explain',
            ]
        };
    },
    methods: {
        getQuestion(){
            let me = this;
            axios
                .get("/api/contests/config-questions/show/" + me.model_id)
                .then(response => {
                    me.question = response.data[0].question;
                    me.order = response.data[0].order;
                    me.slug = response.data[0].slug;
                })
                .catch(function (error) {});
        },
        getArrayQuestions() {
            let me = this;
            axios
                .get("/api/contests/config-questions?paginate=false&contest_id=" + me.model_id)
                .then(function (response) {
                    me.order = response.data.length > 0 ? response.data.length : 0;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;

            if (me.validForm()) {
                axios
                    .post(
                        `/api/contests/config-questions`,
                        {
                            question : me.question,
                            slug : me.slug,
                            order : me.order,
                            contest_id : me.parent_id
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.errors
                        ) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(
                        "/api/contests/config-questions/" + me.model_id,
                        {
                            question : me.question,
                            slug : me.slug,
                            order : me.order,
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                        me.question = response.question;
                        me.slug = response.slug;
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.question) {
                me.allerrors.question = ["El campo Enunciado es obligatorio."];
                valid = false;
            } else if (me.question.length > 190) {
                me.allerrors.question = [
                    "El campo nombre debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.question = [""];
            }
            if (!me.slug) {
                me.allerrors.slug = ["El campo Variable es obligatorio."];
                valid = false;
            } else if (me.slug.length > 190) {
                me.allerrors.slug = [
                    "El campo nombre debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.slug = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                name: null,
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        this.getArrayQuestions();
        if (this.model_id > 0) {
            this.getQuestion();
        }
        return this.model_id;
    },
};
</script>
<style>
    .show-error {
        display: block;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #f86c6b;
    }
    .multiselect, .multiselect__input, .multiselect__single {
        font-size: 14px;
    }
    .multiselect__content-wrapper{
        max-height: 180px !important;
    }
</style>
